import React, { Component } from 'react';
import styles from '../../../Assets/Styles/Components/Book/Packages/Modal.module.css';

class Modal extends Component {
    render() {
        const { onCloseModal, modalShow } = this.props;
        return (
            <div className={`${styles.mymodalContainer} ${modalShow ? styles.active : ''}`} onClick={onCloseModal}>
                <div
                    className={`${styles.mymodal} ${modalShow ? styles.active : ''}`}
                    onClick={(e) => { e.stopPropagation(); }}
                >
                    <div className={`${styles.header} ${styles.withOutBorder}`}>
                        <p>به زودی این گزینه فعال خواهد شد</p>
                        <span
                            onClick={onCloseModal}
                            className={styles.closeMymodal}
                        >
                            &#10006;
                        </span>
                    </div>

                    {/* <div className={styles.text}>
                        <ul>
                            {
                                features.map((i) => {
                                    return (
                                        <li>
                                            <img src="" alt="" className={styles.icon} />
                                            <p> {i} </p>
                                        </li>);
                                })
                            }
                        </ul>
                    </div> */}
                </div>
            </div>
        );
    }
}

export default Modal;
